/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_Closure_ReasonInputs */

const en_po_col_closure_reason = /** @type {(inputs: Po_Col_Closure_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closure reason`)
};

/**
* | output |
* | --- |
* | "Closure reason" |
*
* @param {Po_Col_Closure_ReasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_closure_reason = /** @type {((inputs?: Po_Col_Closure_ReasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_Closure_ReasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_closure_reason(inputs)
});